import { IntlShape } from 'react-intl';

import { Option } from '../OptionList';
import { SubtitlesRatio, subtitlesRatioValues } from '../Subtitles/Subtitles.types';

export const animationDuration = 200;

export const qualityAliases: { [key: string]: string } = {
    '1080p': 'FullHD',
    '2000p': '2K',
    '2160p': '4K',
    '2880p': '5K',
    '3384p': '6K',
    '4320p': '8K',
};

export const getSubtitlesSizeOptions = (intl: IntlShape): Option<SubtitlesRatio>[] => [
    {
        name: intl.formatMessage({
            id: 'components.PlayerSkin.afc493b6574d5529ed0ffa6f18f05b20',

            defaultMessage: 'Smaller',
            description: 'Размер субтитров "Уменьшенные"',
        }),
        value: subtitlesRatioValues.SMALL,
    },
    {
        name: intl.formatMessage({
            id: 'components.PlayerSkin.eb6d8ae6f20283755b339c0dc273988b',

            defaultMessage: 'Standard',
            description: 'Размер субтитров "Стандартные"',
        }),
        value: subtitlesRatioValues.NORMAL,
    },
    {
        name: intl.formatMessage({
            id: 'components.PlayerSkin.f36c7e211f1636f324981b1d020c1475',

            defaultMessage: 'Larger',
            description: 'Размер субтитров "Увеличенные"',
        }),
        value: subtitlesRatioValues.LARGE,
    },
];

export const subtitlesRatioLocalStorage = 'subtitlesRatio';
